import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { doc, updateDoc } from "firebase/firestore";
import { firestore } from "../firebase";

const BookingPopup = ({ booking, onClose }) => {
  const navigate = useNavigate();
  if (!booking) return null;

  // Prefer new structure (`raw`) if available
  const raw = booking.raw || booking;

  const bill = raw.bill || {};
  const customer = raw.customer || {};
  const vehicle = raw.vehicle || {};
  const source = raw.source || {};
  const policy = raw.policySnapshot || {};

  const fullName =
    customer.fullName ||
    `${customer.firstName || ""} ${customer.lastName || ""}`.trim();
  const vehicleType = vehicle.vehicleType || "Vehicle";

  const dailyRate = bill.dailyRate ?? 0;
  const baseCost = bill.baseCost ?? 0;
  const extraHoursCost = bill.extraHoursCost ?? 0;
  const totalCost = bill.totalCost ?? 0;

  const cancellationInsurance = policy.cancellationInsurance;
  const insuranceAmount = policy.insuranceAmount;

  const rentalDays = bill.rentalDays ?? 0;
  const paidExtraHours = bill.paidExtraHours ?? 0;
  let hours = "hours";
  if (paidExtraHours == 1) hours = "hour";
  let days = "day";
  if (rentalDays == 1) days = "day";
  const rentalTimeTxt = `${rentalDays} ${days} and ${paidExtraHours} ${hours}`;

  const contactInfo = customer.email;
  const bookingMethod = source.bookingMethod || "N/A";

  const startTime = booking.start_time || new Date(raw.startDate).getTime();
  const endTime = booking.end_time || new Date(raw.endDate).getTime();

  const currentStatus = raw.status || "booked";

  return (
    <Dialog open={Boolean(booking)} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Booking Details</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1">
          {vehicleType} - {fullName}
        </Typography>

        <Typography variant="body2" sx={{ mt: 1 }}>
          <strong>From:</strong> {moment(startTime).format("LLLL")}
        </Typography>
        <Typography variant="body2">
          <strong>To:</strong> {moment(endTime).format("LLLL")}
        </Typography>
        <Typography variant="body2">
          <strong>Rental Time:</strong> {rentalTimeTxt}
        </Typography>

        <Typography variant="body2" sx={{ mt: 2 }}>
          <strong>Daily Rate:</strong> ₱{dailyRate.toFixed(2)}
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          <strong>Base Cost:</strong> ₱{baseCost.toFixed(2)}
        </Typography>
        <Typography variant="body2">
          <strong>Extra hours:</strong> ₱{extraHoursCost.toFixed(2)}
        </Typography>

        {cancellationInsurance && (
          <Typography variant="body2">
            <strong>Cancellation Protection:</strong> ₱
            {insuranceAmount.toFixed(2)}
          </Typography>
        )}

        <Typography variant="body2" sx={{ mt: 2 }}>
          <strong>Total Cost:</strong> ₱{totalCost.toFixed(2)}
        </Typography>

        <Typography variant="body2" sx={{ mt: 2 }}>
          <strong>Booking Method:</strong> {bookingMethod}
        </Typography>

        {contactInfo && (
          <Typography variant="body2">
            <strong>Contact:</strong> {contactInfo}
          </Typography>
        )}

        <Typography variant="body2" sx={{ mt: 2 }}>
          <strong>Status:</strong>{" "}
          {currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1)}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
        <Button
          onClick={() => navigate(`/booking/${booking.id}`)}
          color="secondary"
          variant="outlined"
        >
          Manage
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BookingPopup;
